import React, { Component } from 'react'
import logo from './../Images/gfsoft_small.svg'
import {Link} from 'react-router-dom'

class HeaderDetail extends Component {
    
    render() {
        return (
            <div className="header-detail">
                <Link to={"/"}>
                    <span className="esupport" title="e-Support GFSOFT"></span>&nbsp;
                    <img src={logo} alt="GFSOFT" title="e-Support GFSOFT"/>
                </Link>
            </div>
        )
    }
}

export default HeaderDetail
